module.exports = __webpack_public_path__ + "img/20221116184505955.82ee8349.png";